export default "__VITE_ASSET__a64b5e81__"